import React from "react";
import { Link } from "react-router-dom";
import { Play, Sparkles, ArrowRight } from "lucide-react";

/**
 * iter122 — Partner reel pin.
 *
 * Auto-mounts a "Watch their 60-second reel" CTA at the top of any
 * direct-book partner's campsite detail page. Pulls the reel path from
 * a static map keyed by canonical + duplicate campsite_ids so every
 * known alias of the partner site still surfaces the reel.
 *
 * When the campsite isn't in the map, the component returns null and
 * adds zero DOM — no extra weight to the 22k regular listing pages.
 */

// canonical → reel path. Aliases share the same target so duplicates work.
const PARTNER_REELS = {
  // iter131 — Dulas Glamping partner pin removed per user request.
  // Frowen Fields (Pembrokeshire) — direct-book partner.
  cs_osm_1168515653: {
    path: "/share/frowen-fields",
    title: "Frowen Fields · 60-second reel",
    subtitle: "See the dome at dusk, the coast path, and the no-booking-fee story.",
  },
  cs_pu_9f46985215: {
    path: "/share/frowen-fields",
    title: "Frowen Fields · 60-second reel",
    subtitle: "See the dome at dusk, the coast path, and the no-booking-fee story.",
  },
};

export default function PartnerReelPin({ campsiteId }) {
  const reel = PARTNER_REELS[campsiteId];
  if (!reel) return null;

  return (
    <Link
      to={reel.path}
      className="group block border-2 border-[#ff4500] bg-gradient-to-r from-[#ff4500] to-[#e63e00] text-white hover:brightness-110 transition-all shadow-[0_3px_0_0_#0e0e0e] mb-5"
      data-testid="partner-reel-pin"
    >
      <div className="p-4 sm:p-5 flex items-center gap-4">
        <div className="flex-shrink-0 w-12 h-12 sm:w-14 sm:h-14 bg-white text-[#ff4500] flex items-center justify-center group-hover:scale-105 transition-transform">
          <Play className="w-5 h-5 sm:w-6 sm:h-6 fill-current" strokeWidth={2.2} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] mono uppercase tracking-[0.18em] opacity-90 inline-flex items-center gap-1.5 mb-0.5">
            <Sparkles className="w-3 h-3" /> Partner spotlight reel
          </div>
          <div className="font-display text-base sm:text-lg leading-tight truncate">
            {reel.title}
          </div>
          <div className="text-[11px] sm:text-xs opacity-90 mt-0.5 line-clamp-1">
            {reel.subtitle}
          </div>
        </div>
        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform flex-shrink-0" />
      </div>
    </Link>
  );
}
